
<template>
    <b-modal :no-close-on-backdrop="true" id="modal-Create" title="Requestor Company" hide-footer :centered="true" v-model="open">
        <b-form>
            <gofix-form-dropdown
                label="Company"
                vLabel="name"
                :class="{'run-loading small-loading': loading}"
                :clearable="true"
                v-model="company"
                :options="requestorCompanies">
            </gofix-form-dropdown>
        </b-form>
        <b-button-group class="d-block text-right p-1rem">
            <gofix-button :disabled="Item && (Item.status === 'Cancelled' || disabled)" label="APPLY" @click="applyData" noBorder></gofix-button>
        </b-button-group>
    </b-modal>
</template>
<script>

import { mapGetters } from 'vuex';
import LiquorTree from 'liquor-tree'
export default {
    name: 'modal-nature-of-feedback',
    components: {
        [LiquorTree.name]: LiquorTree,
    },
    props: {
        value: {
            type: Boolean,
            default: false
        },
        contract_id: {
            type: Number,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            open: false,
            loading: false,
            company: null,
            requestorCompanies: []
        }
    },
    watch: {
        value: function (val) {
            if(val) {
                this.company = null;
                this.getRequestorCompanies();
            }
            this.open = val;
        },
        open: function (val) {
            this.$emit('input', val);
        }
    },
    computed: {
        ...mapGetters({
            Item: "CaseManagementController/Item",
        }),
    },
    created() {
        this.getRequestorCompanies();
    },
    methods: {
        getRequestorCompanies() {
            this.requestorCompanies = [];
            if(!this.contract_id) return;
            this.loading = true;
            this.$store.dispatch("CaseSettingsController/getListCaseRequestorCompany", {
                page: 1,
                limit: -1,
                filter: {
                   contract_id: this.contract_id
                },
                sortColumn: "name",
                sortDirection: "asc",
            })
            .then(result => {
                this.requestorCompanies = result.items;
                this.loading = false;
            })
            .catch(err => {
                this.loading = false;
            })
        },
        applyData() {
            this.$emit('updateData', this.company && this.company.name ? this.company.name : null)
            this.open = false;
        }
    }
}
</script>